import styles from './functions.module.scss';
import modoBUPImage from '../../assets/modoBUP.svg';
import resourcesImage from '../../assets/Recursos.svg';
import dataImage from '../../assets/sociograma.svg';
import { useTranslation } from 'react-i18next';

const Functions = () => {
	const [t] = useTranslation();

	return (
		<section id="functions" className={styles.container}>
			<div className={styles.content_wrapper}>
				<div className={styles.header}>
					<h1>{t('section.functions.title')}</h1>
				</div>
				<ul className={styles.featlist}>
				
					<li className={styles.item}>
					<img src={resourcesImage}/>
						<h5 className={styles.title}>
							{t('section.functions.resourcesTitle')}
						</h5>
						<p className={styles.description}>
							{t('section.functions.resourcesDescription')}
						</p>
					</li>

					<li className={styles.item}>
						<img src={modoBUPImage}/>
						<h5 className={styles.title}>
							{t('section.functions.BUPTitle')}
						</h5>
						<p className={styles.description}>
							{t('section.functions.BUPDescription')}
						</p>
					</li>

					<li className={styles.item}>
						<img src={dataImage}/>
						<h5 className={styles.title}>
							{t('section.functions.dataTitle')}
						</h5>
						<p className={styles.description}>
							{t('section.functions.dataDescription')}
						</p>
					</li>
				</ul>
			</div>
		</section>
	);
};

export default Functions;
